import { Dialog, DialogContent, IconButton, DialogProps as MuiDialogProps, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import {
  StyledBtn,
  StyledDialogAction,
  StyledHeaderWrapper,
  StyledIconClose,
  StyledIconWrapper,
  StyledMainWrapper,
  StyledTitle,
} from 'src/styles/signup/stepsModal';

const dialogContentStyles = { padding: 0 };

interface ModalProps {
  setIsOpen: any;
  messageTitle: string;
  topImage?: React.ReactNode;
  headerPosition?: 'flex-start' | 'flex-end' | 'center';
  buttons?: {
    btnTitle: string;
    btnStyle: 'underlinedBtn' | 'filledBtn' | 'emptyBtn';
    onClick?: () => void;
    disabled?: boolean;
    children?: any;
  }[];
  btnPosition?: 'btnEnd' | 'btnStart' | 'btnCenter' | 'btnBetween';
}

type ModalPropsType = ModalProps & MuiDialogProps;

const btnProps: {
  emptyBtn: { color: 'inherit'; variant: 'outlined' };
  underlinedBtn: object;
  filledBtn: { color: 'primary'; variant: 'contained'; sx: { boxShadow: 'none' } };
} = {
  underlinedBtn: {},
  filledBtn: { color: 'primary', variant: 'contained', sx: { boxShadow: 'none' } },
  emptyBtn: { color: 'inherit', variant: 'outlined' },
};

const Modal: React.FC<ModalPropsType> = ({
  setIsOpen,
  messageTitle,
  topImage,
  buttons,
  children,
  btnPosition = 'btnCenter',
  headerPosition = 'center',
  ...props
}) => {
  const theme = useTheme();

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog onClose={handleClose} {...props}>
      <StyledMainWrapper>
        <StyledIconWrapper>
          <IconButton onClick={handleClose}>
            <StyledIconClose />
          </IconButton>
        </StyledIconWrapper>

        <StyledHeaderWrapper sx={{ alignItems: headerPosition }}>
          {topImage || null}
          <StyledTitle>
            <p>{messageTitle}</p>
          </StyledTitle>
        </StyledHeaderWrapper>
        <DialogContent style={dialogContentStyles}>{children}</DialogContent>
        <StyledDialogAction btn={btnPosition}>
          {buttons
            ? buttons.map(({ onClick, btnStyle, btnTitle, children, ...rest }) => {
                const onBtnClick = () => {
                  if (typeof onClick === 'function') {
                    onClick();
                  } else {
                    handleClose();
                  }
                };

                return (
                  <StyledBtn
                    {...btnProps[btnStyle]}
                    onClick={onBtnClick}
                    btn={btnStyle}
                    theme={theme}
                    {...rest}
                    key={btnTitle}>
                    {btnTitle}
                    {children}
                  </StyledBtn>
                );
              })
            : null}
        </StyledDialogAction>
      </StyledMainWrapper>
    </Dialog>
  );
};

export default Modal;
